import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import { GetServerSideProps } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import { useWindowSize } from 'usehooks-ts';

import { rudderstackTrackEvent } from '@/api/rudderstack/client';
import Layout from '@/modules/core/components/Layout';
import {
  CategoriesResponse,
  HotDeal,
  HotDealsPageProps,
  HotDealsResponse,
} from '@/modules/core/types';
import HotDealCard from '@/modules/profile/components/HotDealCard';

interface ContactData {
  name: string;
  mobile: string;
  email: string;
}
// interface LinkData {
//   text: string;
//   href: string;
// }

export default function HotDealsPage({
  initialCategories,
  initialHotDeals,
}: HotDealsPageProps) {
  // const [categoryId, setCategoryId] = useState('');
  // const [categories, setCategories] = useState<Category[]>([]);
  const [hotDeals, setHotDeals] = useState<HotDeal[]>([]);
  const windowSize = useWindowSize();

  const devenirPartenaireRef = useRef<null | HTMLDivElement>(null);

  const devenirPartenaireRefHandleClick = () => {
    devenirPartenaireRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<ContactData>({
    defaultValues: {},
  });

  const onSubmit = (data: ContactData) => {
    fetch('/api/spreadwriter/', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileId: '1P-9mutypA4kj87aFdr91qFQpuCoxHgIT6IW94URC1Mw',
        columns: [data.name, data.mobile, data.email],
      }),
    });
    reset();
  };

  useEffect(() => {
    // if (Array.isArray(initialCategories)) {
    //   setCategories(initialCategories);
    // }
    rudderstackTrackEvent('page_view', { page_type: `bon plans` });

    setHotDeals(initialHotDeals);
  }, [initialCategories, initialHotDeals]);

  // const fetchHotDeals = async () => {
  //   try {
  //     const apiUrl = '/api/hot-deals-handler';
  //     const response: AxiosResponse<HotDealsResponse> = await axios.get(
  //       apiUrl,
  //       { params: { categoryId } }
  //     );
  //     return setHotDeals(response.data.hotDeals.data);
  //   } catch (error) {
  //     console.error('Error fetching hot-deals:', error);
  //     return [];
  //   }
  // };

  // const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setCategoryId(e.target.value);
  // };

  // const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   fetchHotDeals();
  // };

  // const linkData: LinkData[] = [
  //   { text: 'voitures', href: '/ads/c/Véhicules/?page=1' },
  //   { text: 'immobilier', href: '/ads/c/Immobilier/?page=1' },
  //   {
  //     text: 'vêtements',
  //     href: '/ads/c/Habillement%20et%20Bien%20Etre/?page=1',
  //   },
  //   {
  //     text: 'accessoires',
  //     href: '/ads/c/Habillement%20et%20Bien%20Etre/Sacs%20et%20Accessoires/?page=1',
  //   },
  //   {
  //     text: 'smartphones',
  //     href: '/ads/c/Informatique%20et%20Multimedias/Téléphones/?page=1',
  //   },
  //   {
  //     text: 'appareils électroniques',
  //     href: '/ads/c/Informatique%20et%20Multimedias/Accessoires%20informatiques%20et%20Gadgets/?page=1',
  //   },
  //   {
  //     text: 'équipements de maison',
  //     href: '/ads/c/Pour%20la%20Maison%20et%20Jardin/Electroménagers%20et%20Vaisselles/?page=1',
  //   },
  // ];

  const DescriptionLink: React.FC<{ href: string }> = ({ href, children }) => (
    <Link className="text-black underline font-semibold" href={href}>
      {children}
    </Link>
  );

  return (
    <div className="relative md:-top-14 w-full justify-center items-center mx-auto bg-contain bg-no-repeat">
      <div
        className="w-full h-[260px] md:h-[360px] flex flex-col !justify-center !items-center font-black gap-y-2"
        style={{
          backgroundImage: `url('/media/hotDealsCover.png')`,
          width: '100%',
          backgroundPosition: 'center',
        }}
      >
        <span className="text-xl md:text-3xl text-white uppercase">
          Profitez de Nos
        </span>
        <div className="relative flex flex-wrap items-center justify-center neons text-4xl md:text-6xl ">
          <h1>BONS PLANS EXCLUSIFS!</h1>
          <Image
            loading="lazy"
            src={'/media/hotDealpourcentage.png'}
            alt=""
            width={30}
            height={30}
            className={`absolute -right-[280px] top-[40px] w-[280px] ${
              windowSize.width < 1275 ? '!hidden' : ''
            } `}
            unoptimized
          />
        </div>
        <button
          className="flex justify-center items-center text-white underline "
          onClick={devenirPartenaireRefHandleClick}
        >
          <h3 className=" flex items-center md:text-lg font-semibold w-max pr-3 mb-5">
            Devenir un partenaire
          </h3>
        </button>

        <span className="text-xl md:text-2xl text-white neons">
          Bientôt disponible, restez branchés ...
        </span>
      </div>
      <div className="flex justify-center mx-auto w-full ">
        <div className="flex flex-wrap justify-center max-w-[1100px]">
          {hotDeals
            .slice()
            .sort((a, b) => a.id - b.id)
            .map(
              (deal) =>
                deal.attributes.active && (
                  <HotDealCard key={deal.id} deal={deal} />
                )
            )}
        </div>
      </div>

      <span ref={devenirPartenaireRef}></span>

      <div className=" bg-neutral-50 flex flex-col justify-center items-center mt-24 py-10 ">
        <span className="text-center bg-primary p-2 text-white mx-auto my-4 truncate text-xl md:text-3xl uppercase font-extrabold  ">
          Devenir un partenaire
        </span>
        <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center gap-x-0 md:gap-x-10 py-10">
          <div>
            <img src="/media/partnership.png" alt="" />
          </div>
          <div className="flex justify-center flex-col w-full md:w-[30vw]">
            <form
              className="flex flex-col m-5"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="mb-6">
                <div className="mb-2">
                  <label className="block text- font-bold" htmlFor="name">
                    Nom
                  </label>
                </div>
                <div>
                  <input
                    className="bg-neutral-200/50 appearance-none border-2 border-neutral-200/50 rounded w-full py-2 px-4 text- leading-tight focus:outline-none focus:bg-gray-500/20"
                    id="last-name"
                    type="text"
                    {...register('name')}
                    required
                  />
                </div>
              </div>
              <div className="mb-6">
                <div className="mb-2">
                  <label className="block text- font-bold" htmlFor="mobile">
                    Teléphone
                  </label>
                </div>
                <div>
                  <input
                    className="bg-neutral-200/50 appearance-none border-2 border-neutral-200/50 rounded w-full py-2 px-4 text- leading-tight focus:outline-none focus:bg-gray-500/20"
                    id="mobile"
                    type="tel"
                    pattern="([0-9]{2}\s?[0-9]{3}\s?[0-9]{3})|([0-9]{2}\s?[0-9]{2}\s?[0-9]{2}\s?[0-9]{2}\s?)"
                    {...register('mobile')}
                    required
                  />
                </div>
              </div>
              <div className="mb-6">
                <div className="mb-2">
                  <label
                    className="inline-block text- font-bold"
                    htmlFor="mobile"
                  >
                    Email
                  </label>
                </div>
                <div>
                  <input
                    className="bg-neutral-200/50 appearance-none border-2 border-neutral-200/50 rounded w-full py-2 px-4 text- leading-tight focus:outline-none focus:bg-gray-500/20"
                    id="email"
                    type="email"
                    {...register('email')}
                  />
                </div>
              </div>
              <div className="mt-8  mx-auto">
                <button
                  className={`btn btn-primary rounded px-10 ${
                    isSubmitting && 'loading'
                  }`}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Envoyer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="flex max-w-[1080px] justify-center md:mx-auto mt-24 text-sm">
        <p className="px-10">
          <DescriptionLink href="/bons-plans-tayara/">
            Bons Plans Tayara
          </DescriptionLink>
          {/* , votre destination ultime pour dénicher les meilleures offres en
          ligne ! Notre plateforme regorge d&apos;un vaste choix de produits de
          qualité à des prix imbattables. Explorez notre catalogue diversifié,
          comprenant des{' '}
          {linkData.map((link, index) => (
            <React.Fragment key={index}>
              <DescriptionLink href={link.href}>{link.text}</DescriptionLink>
              {index !== linkData.length - 1 && ', '}
            </React.Fragment>
          ))}
          et bien plus encore, provenant de marques renommées. Ne manquez pas
          nos promotions exclusives et nos deals chauds qui vous permettront
          d&apos;économiser gros sur vos achats en ligne. Avec{' '}
          <DescriptionLink href="/">Tayara</DescriptionLink>, faites de la
          chasse aux bonnes affaires une expérience simple et enrichissante.
          Rejoignez-nous dès aujourd&apos;hui et explorez un univers de
          possibilités où chaque article raconte une histoire! */}
          , votre destination ultime pour dénicher les meilleures offres en
          ligne ! Notre plateforme regorge d&apos;un vaste choix de produits de
          qualité à des prix imbattables. Ne manquez pas nos promotions
          exclusives et nos deals qui vous permettront de faire de bonnes
          afaires. Avec <DescriptionLink href="/">Tayara</DescriptionLink>,
          faites de la chasse aux bonnes affaires une expérience simple et
          enrichissante. Rejoignez-nous dès aujourd&apos;hui et explorez un
          univers de possibilités où chaque article raconte une histoire!
        </p>
      </div>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<
  HotDealsPageProps
> = async () => {
  try {
    const hotDealsApiUrl = `${process.env.strapiUri}/hot-deals?populate=*`;

    const axiosInstance = axios.create({
      headers: {
        Authorization: `Bearer 8d6317ea4297ad4dc09f840fab8df413214ac4fccd71a24bbf5abb75deec51bab0a145d42044992a76080c34d3b6e0d83c98ab7ecf976c0e507b1f942009c2afb282ae63685557872a527ca6f3e12a7af366c47b220e69bc3c881d5d9d3b8da68d3c77976fe1ac0d301f5f877693d6fd9c93da9294024c7ea5b2b906f4914ab7`,
      },
    });

    const hotDealsResponse = await axiosInstance.get<HotDealsResponse>(
      hotDealsApiUrl
    );
    const initialHotDeals = hotDealsResponse.data.data;

    const categoriesApiUrl = `${process.env.strapiUri}/categories`;
    const categoriesResponse = await axiosInstance.get<CategoriesResponse>(
      categoriesApiUrl
    );
    const initialCategories = categoriesResponse.data.data;

    return {
      props: { initialCategories, initialHotDeals },
    };
  } catch (error) {
    console.error('Error fetching initial data:', error);
    return {
      props: { initialCategories: [], initialHotDeals: [] },
    };
  }
};

HotDealsPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
